define('kitpDetailTabController',[
  'module',
  'underscore',
  'backbone',
  'app',
  'kitpDetailView',
  'settings'
], function(
  module,
  _,
  Backbone,
  App,
  View
) {
  'use strict';

  var KitpDetailTabController = {
    showTab: function(data) {
      if (!data.tab) {
        data.tab = 'detail';
      }
      this.showKitpInfo(data);
    },

    showKitpInfo: function(data) {
      var that = this;
      this.model = data.model;
      this.tab = data.tab;
      this.data = data;
      that.createView();
    },

    createView: function() {
      var view;
      view = new View({
        model: this.model
      });
      view.tempModel = new Backbone.Model(this.model.toJSON());
      this.view = view;

      App.regions.getRegion('main').currentView.getRegion('content').currentView.getRegion('kitpDetailTab').show(view);
    }
  };

  module.exports = KitpDetailTabController;
});
